// src/jsx/pages/Production_Management/Manage_Daily_Orders/Daily_Orders.js
import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { Button, Badge, Dropdown } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import bgimage from '../../../../images/items/items.jpg';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker from "react-multi-date-picker";
import AddWorkAssign from './../../../modal/Production_Management/Manage_Daily_Order/Assign_Work';
import { Row, Col, Tab, Nav } from "react-bootstrap";
import NeededRawMaterial from '../../../modal/Production_Management/Menu_Maker/Needed_RawMaterial';
import View from '../../../modal/Production_Management/Manage_Daily_Order/ViewDailyOrder';
import ViewDailyOrders from '../../../modal/Production_Management/Manage_Daily_Order/ViewDailyOrder';
import axios from 'axios';
import swal from "sweetalert2";
import { Tooltip, OverlayTrigger } from "react-bootstrap";


const baseURL = process.env.REACT_APP_API_BASE_URL || "http://192.168.3.110:1712/api";

const ProductionTime = ({ production_time }) => {
  const [remaining, setRemaining] = useState('');

  useEffect(() => {
    const updateRemaining = () => {
      if (!production_time) {
        setRemaining('-');
        return;
      }
      const match = production_time.match(/(.*) to (.*) \((.*)\)/);
      if (!match) return;
      const startStr = match[1].trim();
      const endStr = match[2].trim();

      const now = new Date();
      const start = new Date(now.toDateString() + ' ' + startStr);
      const end = new Date(now.toDateString() + ' ' + endStr);

      let diff = end - now;
      if (diff <= 0) {
        setRemaining('Completed');
        return;
      }
      const hrs = Math.floor(diff / 1000 / 60 / 60);
      const mins = Math.floor((diff / 1000 / 60) % 60);
      setRemaining(`Remaining: ${hrs} hrs ${mins} min`);
    };

    updateRemaining();
    const interval = setInterval(updateRemaining, 30000);
    return () => clearInterval(interval);
  }, [production_time]);

  if (!production_time) return <label className='text-muted'>-</label>;

  const match = production_time.match(/(.*) to (.*) \((.*)\)/);
  const start = match ? match[1].trim() : '';
  const end = match ? match[2].trim() : '';
  const duration = match ? match[3].trim() : '';

  return (
    <div className="d-flex flex-column align-items-start">
      <label className="text-black font-w500 fs-7">
        {start} | {end}
      </label>
      <small className="text-primary fw-bold">
        {duration} ({remaining})
      </small>
    </div>
  );
};

const Daily_Orders = () => {
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const user_id = parseInt(localStorage.getItem("user_id"), 10);

  const [slectedDate, setSelDate] = useState(new Date());
  const [datas, setData] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);

  const [modalType, setModalType] = useState("");
  const [open, setOpen] = useState(false);
  const [key, setKey] = useState('today_item');

  const [staffList, setStaffList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const tableRef = useRef(null);

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const fetchData = () => {
    const params = { date: formatDate(slectedDate) };
    axios.get(`${baseURL}/daily-orders`, { params })
      .then(res => {
        setData(res.data.data || []);
        setHasFetched(true);
      })
      .catch(err => {
        console.error('fetch daily-orders error', err);
        setHasFetched(true);
      });

    // Trigger update endpoints (keep best-effort)
    axios.get(`${baseURL}/trigger-production-update`).catch(() => {});
    axios.post(`${baseURL}/update-daily-corp-orders-by-date/${formatDate(slectedDate)}`).catch(() => {});
    axios.post(`${baseURL}/update-daily-orders-by-date/${formatDate(slectedDate)}`).catch(() => {});
  };

  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (hasFetched && tableRef.current) {
      if (!$.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable({
          responsive: true,
          ordering: false,
          language: { lengthMenu: "Show _MENU_" },
          dom:
            "<'row'<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l><'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>>" +
            "<'table-responsive'tr>" +
            "<'row'<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i><'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>>"
        });
      }
    }
  }, [hasFetched]);

  useEffect(() => {
    // fetch staff list
    axios.get(`${baseURL}/dropdown/getstaff_by_role/5?branch_id=${branch_id}`)
      .then(response => {
        const items = Array.isArray(response.data?.data) ? response.data.data : [];
        setStaffList(items);
      })
      .catch(err => console.error('fetch staff error', err));
  }, [branch_id]);

  const softRefresh = () => {
    setHasFetched(false);
    if (tableRef.current && $.fn.dataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
    fetchData();
  };

  // Helper to resolve numeric status to UI
  const getStatusNumber = (row) => {
    // prefer work_status_code if provided by API (your sample had that)
    if (typeof row.work_status_code !== 'undefined' && row.work_status_code !== null) return Number(row.work_status_code);
    if (typeof row.status !== 'undefined' && row.status !== null) return Number(row.status);
    // fallback: derive from work_status string (some APIs return text)
    if (row.work_status) {
      const mapping = {
        'Assigned': 0,
        'Rework': 1,
        'Update Work': 2,
        'Completed': 3,
        'Started': 4,
        'Not Yet Started': 7
      };
      return mapping[row.work_status] ?? null;
    }
    return null;
  };

 function getStaffId(data) {
  return data.staff_id ??
    (Array.isArray(data.staff) && data.staff.length > 0 ? data.staff[0].id : null);
}


  const StartedModel = (data) => {
    swal.fire({
      html: `
        <div class="alert alert-success px-2 py-2" role="alert">
          Are You Sure Want to change status ?
        </div>
        <p class="text-center"><b>Work Started</b></p>
      `,
      showCancelButton: true,
      confirmButtonText: 'Yes! Start',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: { title: 'fs-6', cancelButton: 'btn btn-sm btn-secondary', confirmButton: 'btn btn-sm btn-success', htmlContainer: 'text-left' },
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((result) => {
      if (!result.isConfirmed) return;
      const payload = {
        assignment_date: formatDate(slectedDate),
        staff_id: getStaffId(data),
        item_id: data.item_id,
        status: 4
      };
      axios.post(`${baseURL}/update-work-status`, payload)
        .then(() => { toast.success("Work Started Successfully!"); softRefresh(); })
        .catch(() => { toast.error("Work Start Failed"); softRefresh(); });
    });
  };

  const ConfirmationModal = (data) => {
    swal.fire({
      html: `
        <div class="alert alert-success px-2 py-2" role="alert">
          Are You Sure Want to change status ?
        </div>
        <p class="text-center"><b>Work Completed</b></p>
      `,
      showCancelButton: true,
      confirmButtonText: 'Yes! Completed',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: { cancelButton: 'btn btn-sm btn-secondary', confirmButton: 'btn btn-sm btn-success' },
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((result) => {
      if (!result.isConfirmed) return;
      const payload = {
        assignment_date: formatDate(slectedDate),
        staff_id: getStaffId(data),
        item_id: data.item_id,
        status: 3
      };
      axios.post(`${baseURL}/update-work-status`, payload)
        .then(() => { toast.success("Work Completed Successfully!"); softRefresh(); })
        .catch(() => { toast.error("Work Completion Failed"); softRefresh(); });
    });
  };

  const ReworkModal = (data) => {
    // build staff options HTML from staffList
    const staffOptionsHtml = staffList.map(s => `<option value="${s.sno}">${s.name}</option>`).join('');
    swal.fire({
      html: `
        <div class="alert alert-danger px-2 py-2">Are You Sure Want to change status ?</div>
        <p class="text-center"><b>Rework</b></p>
        <div class="mt-4 text-start">
          <label class="fs-7">Reason <span style="color:red">*</span></label>
          <textarea id="reason" rows="2" placeholder="Enter Reason" style="width:100%;border-radius:5px;padding:4px;"></textarea>
        </div>
        <div class="mt-3 text-start">
          <label class="fs-7">Select Staff <span style="color:red">*</span></label>
          <select id="staffSelect" style="width:100%;border-radius:5px;padding:6px;">
            <option value="">-- Select Staff --</option>
            ${staffOptionsHtml}
          </select>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Yes! Rework',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: { confirmButton: 'btn btn-sm btn-danger', cancelButton: 'btn btn-sm btn-secondary' },
      allowOutsideClick: false,
      allowEscapeKey: false,
      preConfirm: () => {
        const reason = document.getElementById('reason')?.value.trim();
        const staffId = document.getElementById('staffSelect')?.value;
        if (!reason) return swal.showValidationMessage("Please enter a reason.");
        if (!staffId) return swal.showValidationMessage("Please select a staff.");
        return { reason, staffId };
      }
    }).then((result) => {
      if (!result.isConfirmed) return;
      const { reason, staffId } = result.value;
      const payload = {
        assignment_date: formatDate(slectedDate),
        staff_id: getStaffId(data),
        item_id: data.item_id,
        status: 1,
        rework_reason: reason,
        rework_staff_id: Number(staffId)
      };
      axios.post(`${baseURL}/update-work-status`, payload)
        .then(() => { toast.success("Rework Assigned Successfully!"); softRefresh(); })
        .catch(() => { toast.error("Rework Failed"); softRefresh(); });
    });
  };

  const Update = (data) => {
    swal.fire({
      html: `
        <div class="alert alert-info px-2 py-2">Are You Sure Want to Update This Item?</div>
        <p class="text-center"><b>Update</b></p>
        <label class="fs-7">Comments <span style="color:red">*</span></label>
        <textarea id="update-reason" rows="2" placeholder="Enter Comments" style="width:100%;border-radius:5px;padding:4px;"></textarea>
      `,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
      customClass: { confirmButton: 'btn btn-sm btn-success', cancelButton: 'btn btn-sm btn-secondary' },
      allowOutsideClick: false,
      allowEscapeKey: false,
      preConfirm: () => {
        const reason = document.getElementById('update-reason')?.value.trim();
        if (!reason) return swal.showValidationMessage("Please enter a comment.");
        return reason;
      }
    }).then((result) => {
      if (!result.isConfirmed) return;
      const payload = {
        assignment_date: formatDate(slectedDate),
        staff_id: getStaffId(data),
        item_id: data.item_id,
        status: 2,
        update_reason: result.value
      };
      axios.post(`${baseURL}/update-work-status`, payload)
        .then(() => { toast.success("Work Update Saved!"); softRefresh(); })
        .catch(() => { toast.error("Update Failed"); softRefresh(); });
    });
  };

  // Generic change via select (used if you want a single change button)
  const updateWorkStatus = async (row) => {
    const item_id = row.item_id;
    const staff_id = row.staff_id ?? row.staff?.id ?? null;
    const assignment_date = formatDate(slectedDate);

    const statusOptions = { 4: "Start Work", 3: "Mark Completed", 1: "Rework", 2: "Update Work" };

    const { value: selectedStatus } = await swal.fire({
      title: "Change Work Status",
      input: "select",
      inputOptions: statusOptions,
      inputPlaceholder: "Select status",
      showCancelButton: true
    });
    if (!selectedStatus) return;

    let rework_reason = null;
    let update_reason = null;
    let rework_staff_id = null;

    if (Number(selectedStatus) === 1) {
      const { value: info } = await swal.fire({
        title: "Rework Details",
        html: `
          <input id="r_reason" class="swal2-input" placeholder="Rework Reason">
          <input id="r_staff" class="swal2-input" placeholder="Rework Staff ID">
        `,
        preConfirm: () => ({
          r_reason: document.getElementById("r_reason").value,
          r_staff: document.getElementById("r_staff").value
        }),
        showCancelButton: true
      });
      if (!info) return;
      rework_reason = info.r_reason;
      rework_staff_id = info.r_staff ? Number(info.r_staff) : null;
      if (!rework_reason) { swal.fire("Error", "Rework reason is required", "error"); return; }
      if (!rework_staff_id) { swal.fire("Error", "Rework staff ID is required", "error"); return; }
    }

    if (Number(selectedStatus) === 2) {
      const { value } = await swal.fire({ title: "Reason for Update", input: "text", inputPlaceholder: "Enter reason", showCancelButton: true });
      if (!value) return;
      update_reason = value;
    }

    const payload = {
      assignment_date,
      staff_id,
      item_id,
      status: Number(selectedStatus)
    };
    if (Number(selectedStatus) === 1) {
      payload.rework_reason = rework_reason;
      payload.rework_staff_id = rework_staff_id;
    }
    if (Number(selectedStatus) === 2) payload.update_reason = update_reason;

    try {
      await axios.post(`${baseURL}/update-work-status`, payload);
      swal.fire("Success", "Work status updated!", "success");
      fetchData();
    } catch (err) {
      console.error(err);
      swal.fire("Error", "Failed to update status", "error");
    }
  };

  useEffect(() => {
  if (slectedDate) {
    softRefresh();
  }
}, [slectedDate]);

const [openView, setOpenView] = useState(false);
const [viewData, setViewData] = useState(null);

const handleView = async (order_sno) => { 
    try {
        const res = await fetch(`${baseURL}/dailyorder-view?order_sno=${order_sno}`);
        const json = await res.json();

        setViewData(json.sample_data);   // set API data
        setOpenView(true);                // show modal
    } catch (e) {
        console.log("View API error:", e);
    }
};



  // render
  return (
    <>
      <div className="d-flex align-items-center justify-content-between page-titles flex-wrap px-0 py-1 mx-0">
        <div className='mb-2'>
          <div className="mb-0 px-0">
            <h4 className='breadcrumb-header'>Manage Daily Orders</h4>
          </div>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item active">Production Management</li>
          </ol>
        </div>

        <div className='col-lg-5 d-flex justify-content-end gap-3 align-items-end'>
          <div>
            <Link to="#" className="btn btn-primary btn-sm" onClick={() => { setModalType("NeededRawMaterial"); setOpen(true); }}>
              <span className='me-2'><i className="fa-solid fa-basket-shopping fs-8"></i></span>
              Needed Raw Material
            </Link>
          </div>
          <div>
            <Link to="#" className="btn btn-primary btn-sm" onClick={() => { setModalType("WorkAssign"); setOpen(true); }}>
              <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
              Assign Work
            </Link>
          </div>
        </div>

        {open && modalType === "WorkAssign" && <AddWorkAssign show={open} onClose={() => setOpen(false)} slectedDate={slectedDate} />}
{openView && viewData && (
  <ViewDailyOrders
      show={openView}
      onClose={() => setOpenView(false)}
      data={viewData}
  /> 
)}

     {open && modalType === "NeededRawMaterial" && 
              <NeededRawMaterial 
                  show={open} 
                  onClose={() => setOpen(false)} 
                  selectedDate={slectedDate}   // <-- PASS DATE HERE
              />
          }
           
      </div>
 
      <Col xl={12} className='mb-3'>
        <div className="custom-tab-1">
          <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <Nav as="ul" className="nav-tabs">
                <Nav.Item as="li">
                  <Nav.Link eventKey="today_item"><i className="fa-solid fa-bowl-food px-2"></i><label className="fs-6">Today's Item</label></Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link as={Link} to="/manage-daily-orders-rework"><i className="fa-solid fa-person-walking-arrow-loop-left px-2"></i><label className="fs-6">Rework</label></Nav.Link>
                </Nav.Item>
              </Nav>

              <div className="d-flex justify-content-end align-items-center gap-3 flex-wrap">
                <div className='datepicker-wrapper d-flex'>
                  <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                  {/* <DatePicker value={slectedDate} format="DD-MM-YYYY" placeholder='Select Date' onChange={(date) => setSelDate(date ? date.toDate() : null)} onClick={softRefresh}/> */}
                    <DatePicker
                        value={slectedDate}
                        format="DD-MM-YYYY"
                        placeholder="Select Date"
                        onChange={(date) => {
                            const d = date ? date.toDate() : null;
                            setSelDate(d);
                        }}
                        />


                </div>
                {/* <Button className="me-2 btn-sm" variant="primary" onClick={softRefresh}><span className='font-w400'>Submit</span></Button> */}
              </div>
            </div>

            <Tab.Content className="pt-4">
              <Tab.Pane eventKey="today_item">
                <Row>
                  <div className='col-lg-12 mb-2'>
                    <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                      <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                          <th className='min-w-100px'>Items</th>
                          <th className='min-w-80px text-start'>Cooking Quantity</th>
                          <th className='min-w-100px'>Production Time</th>
                          <th className='min-w-100px'>Master</th>
                          <th className='min-w-60px text-center'>Stock</th>
                          <th className='min-w-100px text-end'>Work Status</th>
              
                        </tr>
                      </thead>
                      <tbody className="text-gray-600 fw-semibold fs-7">
                        {datas.length === 0 && hasFetched && (
                          <tr><td colSpan="6" className="text-center text-muted py-2">No data available</td></tr>
                        )}
                        {datas.map((data) => {
                          const statusNum = getStatusNumber(data);
                          return (
                            <tr key={data.item_id}>
                              <td>
                                <div className='d-flex align-items-center justify-content-start gap-2'>
                                  <LightGallery onInit={() => {}} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                    <div data-src={data.item_image || bgimage} className='border rounded px-1 py-0'>
                                      <img src={data.item_image || bgimage} alt={data.item_name} className='cursor-pointer w-50px h-50px' />
                                    </div>
                                  </LightGallery>
                                  <div className='d-flex flex-column align-items-start'>
                                    <label className='text-black font-w500 fs-7'>{data.item_name}</label>
                                    <Badge bg="info" className='py-1 px-2 fs-7'>{data.schedule_name}</Badge>
                                  </div>
                                </div>
                              </td>

                              <td className='text-start'><Badge bg="danger" className='py-1 px-2 fs-7'>{data.quantity}</Badge></td>

                              <td><ProductionTime production_time={data.production_time} /></td>

                              {/* <td className="text-black">{data.staff && data.staff.name ? data.staff.name : (data.staff_name ?? '-')}</td> */}
                              <td className="text-black">
                                {data.staff && data.staff.length > 0 
                                  ? data.staff.map(s => s.name).join(', ')
                                  : (data.staff_name ?? '-')}
                              </td>

                              <td className="text-center">
                                    {statusNum === 0 && (
                                      <i className="fa fa-times text-danger fs-5" aria-hidden="true"></i>
                                    )}

                                    {(statusNum === 1 || statusNum === 2 || statusNum === 4) && (
                                      <i className="fa fa-ellipsis-h text-info fs-5" aria-hidden="true"></i>
                                    )}

                                    {statusNum === 3 && (
                                      <i className="fa fa-check text-primary fs-5" aria-hidden="true"></i>
                                    )}
                                  </td>


                              <td className="text-end">
                                {/* render by numeric status (prefer work_status_code) */}
                                {statusNum === 0 && (
                                  <Dropdown>
                                    <Dropdown.Toggle as="a" className="cursor-pointer">
                                      <label className="text-white py-1 px-2 rounded fs-7" style={{ backgroundColor: '#761586' }}>Work Assigned</label>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item onClick={() => StartedModel(data)}>Started</Dropdown.Item>
                                      <Dropdown.Item onClick={() => Update(data)}>Update</Dropdown.Item>
                                      <Dropdown.Item onClick={() => ReworkModal(data)}>Rework</Dropdown.Item>
                                      <Dropdown.Item onClick={() => ConfirmationModal(data)}>Completed</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                )}

                                {statusNum === 1 && (
                                  <Dropdown>
                                    <Dropdown.Toggle as="a" className="cursor-pointer">
                                      <Badge bg="danger" className="py-1 px-2 fs-7" style={{ animation: "blink 2s infinite" }}>Rework</Badge>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item onClick={() => ConfirmationModal(data)}>Completed</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                )}

                                {statusNum === 2 && (
                                  <Dropdown>
                                    <Dropdown.Toggle as="a" className="cursor-pointer">
                                      <Badge bg="info" className="py-1 px-2 fs-7">Update</Badge>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item onClick={() => ConfirmationModal(data)}>Completed</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                )}

                                {statusNum === 3 && (
                                  <label className="text-white py-1 px-2 rounded fs-7" style={{ backgroundColor: '#33b400' }}>Work Completed</label>
                                )}

                                {statusNum === 4 && (
                                  <Dropdown>
                                    <Dropdown.Toggle as="a" className="cursor-pointer">
                                      <Badge bg="warning" className="py-1 px-2 fs-7">Work Started</Badge>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item onClick={() => Update(data)}>Update</Dropdown.Item>
                                      <Dropdown.Item onClick={() => ReworkModal(data)}>Rework</Dropdown.Item>
                                      <Dropdown.Item onClick={() => ConfirmationModal(data)}>Completed</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                )}
                              </td>
                          

                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Row>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </Col>
    </>
  );
};

export default Daily_Orders;
